import type { InjectionKey } from "vue";
import type { Store } from "vuex";
import { createLogger, createStore, useStore } from "vuex";

import adminDiscountCode from "./modules/adminDiscountCode";
import adminPatients from "./modules/adminPatients";
import auth from "./modules/auth/auth.js";
import billingData from "./modules/billingData";
import breadcrumbs from "./modules/breadcrumbs";
import type { CallState } from "./modules/call";
import call from "./modules/call";
import cart from "./modules/cart";
import createdinvoices from "./modules/createdinvoices";
import doctors from "./modules/doctors";
import employees from "./modules/employees";
import examinations from "./modules/examinations";
import facilities from "./modules/facilities";
import features from "./modules/features";
import invoices from "./modules/invoices";
import language from "./modules/language";
import languages from "./modules/languages";
import loader from "./modules/loader";
import type { MedicalCategories } from "./modules/medicalCategories/medicalCategories";
import medicalCategories from "./modules/medicalCategories/medicalCategories";
import message from "./modules/message";
import modals from "./modules/modals";
import patients from "./modules/patients";
import raports from "./modules/raports";
import referralErrors from "./modules/referralErrors";
import referralGroups from "./modules/referralGroups";
import referrals from "./modules/referrals";
import results from "./modules/results";
import statuses from "./modules/statuses";
import testsToDescribe from "./modules/testsToDescribe";
import user from "./modules/user";
import { env } from "@/config/env.mjs";
import type { AccountCompletion } from "@/store/modules/accountCompletion/accountCompletion";
import accountCompletion from "@/store/modules/accountCompletion/accountCompletion";
import type { AppointmentHoursStore } from "@/store/modules/appointmentHours/appointmentHours";
import appointmentHours from "@/store/modules/appointmentHours/appointmentHours";
import upcomingSchedules from "@/store/modules/appointmentHours/upcomingSchedules";
import type { AuthClinicState } from "@/store/modules/auth/authClinic";
import authClinic from "@/store/modules/auth/authClinic";
import diseases from "@/store/modules/diseases";
import docLanguages from "@/store/modules/docLanguages";
import doctorServices from "@/store/modules/doctorServices";
import patientVisits from "@/store/modules/patientVisits";
import services from "@/store/modules/services/services";

interface State {
  call: CallState;
  authClinic: AuthClinicState;
  medicalCategories: MedicalCategories;
  appointmentHours: AppointmentHoursStore;
  accountCompletion: AccountCompletion;
  user: any;
}

export const keyStore: InjectionKey<Store<State>> = Symbol();

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    language,
    languages,
    user,
    medicalCategories,
    auth,
    patients,
    facilities,
    modals,
    examinations,
    referrals,
    cart,
    doctors,
    statuses,
    message,
    billingData,
    loader,
    results,
    invoices,
    referralGroups,
    features,
    breadcrumbs,
    createdinvoices,
    raports,
    adminPatients,
    referralErrors,
    adminDiscountCode,
    testsToDescribe,
    call,
    authClinic,
    services,
    appointmentHours,
    accountCompletion,
    diseases,
    docLanguages,
    patientVisits,
    employees,
    upcomingSchedules,
    doctorServices,
  },
  strict: env.NODE_ENV !== "production",
});

export function useTypedStore() {
  return useStore(keyStore);
}
